import { useEffect } from 'react'

interface useInitProps {
  setShowOverlay: Function
  filterValuesLoaded : boolean
  filterLoaded : boolean
}

const useDisplaySpinner = (props: useInitProps) => {
  useEffect(() => {
    if(props.filterValuesLoaded && props.filterLoaded){
        props.setShowOverlay(false)
    }
  }, [props.filterValuesLoaded, props.filterLoaded])
}

export default useDisplaySpinner
